@use '~/theme/theme' as *;

.ellipsed {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.amountWithIcon {
  display: flex;
  gap: spacing(0.5);
  justify-content: flex-end;
  align-items: center;
}

.icon {
  color: color(lobster-800);
}

.isInflow {
  color: color(green-800);
}

.small {
  @include icon-size(sm);
}

.medium {
  @include icon-size(md);
}
